import { createSvgComponent } from "../../icon/createSvgComponent";
import MailSend from "@core/__generated__/icon/figma/mail-send.svg";
export default createSvgComponent(MailSend);